import { useCampaignDetailsStepRepository } from './use-campaign-details-step-repository';

export const useCampaignDetailsEditStepRepository = () =>
  useCampaignDetailsStepRepository({ isBudgetAndBiddingEnabled: true });
